import { render } from "./comfirmModal.vue?vue&type=template&id=12ebf452&scoped=true"
import script from "./comfirmModal.vue?vue&type=script&lang=js"
export * from "./comfirmModal.vue?vue&type=script&lang=js"

import "./comfirmModal.vue?vue&type=style&index=0&id=12ebf452&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ebf452"]])

export default __exports__